import {
  AlpineComponent as AlpineComponent,
  ComponentFactory,
  AlpineStore,
  ComponentStores,
  Alpine,
} from 'alpinejs';
import { createApp, Component } from 'vue';

import { pinia } from '@/src/store';

/**
 * Queries for the app via component selector
 */
export function isVueAppInDOM(componentSelector: string): boolean {
  return !!document.querySelector(componentSelector);
}

/**
 * Creates an instance of a Vue app with the provided component as the root of the app,
 * targeting the element matching the given selector
 */
export function renderApp(
  rootComponent: Component,
  selector: string,
  options: { useStore: boolean } = { useStore: true }
): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const props = { ...(window as any)[selector] };

  const app = createApp(rootComponent, props);

  if (options.useStore) {
    app.use(pinia);
  }

  app.mount(selector);
}

export type SelectOption = {
  name: string;
  value: string;
};

export type SelectOptions = SelectOption[];

export function mapEnumsToOptions(enums: string[]): SelectOptions {
  return enums.map((value) => ({
    value,
    name: value.replaceAll('_', ' ').trim(),
  }));
}

export function alpineComponent<
  TComponent extends AlpineComponent<TStores>,
  TStores extends ComponentStores,
  Arg = void
>(
  id: string,
  factory: ComponentFactory<TComponent, Arg>
): (alpine: Alpine) => void {
  return (alpine) => alpine.data(id, factory);
}

export function alpineComponentNoStore<
  TComponent extends AlpineComponent,
  Arg = void
>(
  id: string,
  factory: ComponentFactory<TComponent, Arg>
): (alpine: Alpine) => void {
  return (alpine) => alpine.data(id, factory);
}

export function alpineStore<TStore extends AlpineStore>(
  id: string,
  state: TStore
): (alpine: Alpine) => void {
  return (alpine) => alpine.store(id, state);
}
